<template>
    <div>
        <!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->       
            <div class="col-md-7 fixed-top m-auto" v-if="error!=null">
                <b-alert
                    :show="alert.dismissCountDown"
                    dismissible :variant="error? 'success' : 'danger'"
                    @dismissed="[alert.dismissCountDown=0, mailSent=null]"
                    @dismiss-count-down="countDownChanged">
                    <div class="text-center m-auto pl-4" :class="error? 'text-dark':'text-danger'"> <br>
                    <span  v-if="error"  >  
                      <span class="lead">now you can be part of the new structure</span> 
                    </span>
                      <span v-else class="lead">   errormsg </span>
                    <br><hr>
                    <span>Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes ... </span>
                    </div>
                </b-alert>
            </div>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  
        <div class="card"> 
            <div class="card-block">
            <td class="col-md-8 align-middle">
                    Vous avez été ajouté à la  structure : <span class="font-weight-bold">{{_props.invitation.structure? _props.invitation.structure.name: '' }} </span>  , 
                    
                    avec le rôle  : <span class="font-weight-bold">
                    <span v-if="_props.invitation.users_has_roles.role_id==1">Responsable</span>
                    <span v-else-if="_props.invitation.users_has_roles.role_id==3">Adhérent(e)</span>
                    </span>
            </td>
            
            <td class="col-md-1">
                <b-button variant="info" :disabled="isBusy.Refuser||isBusy.Accepter" class="m-auto" @click="Accepter()">
                    <b-spinner small v-if="isBusy.Accepter"></b-spinner>
                    Accepter
                </b-button>
            </td>
            <td class="col-md-1">
                <b-button variant="default" :disabled="isBusy.Refuser||isBusy.Accepter" class="m-auto" @click="Refuser()">
                    <b-spinner small v-if="isBusy.Refuser"></b-spinner>
                    Refuser
                </b-button>
            </td>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../config/_api";

export default {
    name :"RoleConfirmation",
    data (){
        return {
            isBusy:{
                Accepter : false,
                Refuser : false,
            },
            //token : "",
            tokenExists : null,
            errormsg :"",
            error : null,

      showBottom: false,
      showTop: false

        }
    },
    created() {
        
       // this.token=this.$route.params.token;
        //this.findToken();
    },
    props : {
        invitation: {
            type: Object,
            required: false
        },
        user : {
            type: Object,
            required: false
        },
        

    },
    methods:{
            findToken(){
                this.axios({url: api.url + 'password/find/'+this.invitation.token,method: 'GET' })
                .then(result => {
                    this.tokenExists=true;
                }, error => {
                    this.tokenExists=false;
                    this.errormsg=error;
                });
            },
            Accepter(){
                
                let data = {
                    action : 'Accepter',
                    users_has_roles:this.invitation.users_has_roles.id,
                    users_has_tokens:this.invitation.id
                }

                this.isBusy.Accepter=true;
                this.axios({url: api.url + 'Role/Accepterinvitation/'+this.invitation.token,data:data,method: 'POST' })
                .then(result => {
                    this.error=false;
                    this.isBusy.Accepter=false;
                    let value = {action : data.action ,error : this.error}
                    this.$emit('AccepterRefuser',value);
                }, error => {
                    this.error=true;
                    this.errormsg=error.response.error;
                    this.isBusy.Accepter=false;
                    let value = {action : data.action ,error : this.error}
                    this.$emit('AccepterRefuser',value);
                });

            },
            Refuser(){
                
                let data = {
                    action : 'Refuser',
                    users_has_roles:this.invitation.users_has_roles.id,
                    users_has_tokens:this.invitation.id
                }
                
                this.isBusy.Refuser=true;
                this.axios({url: api.url + 'Role/Refuserinvitation/'+this.invitation.token,data:data,method: 'POST' })
                .then(result => {
                    this.error=false;
                    this.isBusy.Refuser=false;
                    let value =  {action : data.action ,error : this.error};
                    this.$emit('AccepterRefuser',value);
                }, error => {
                    this.error=true;
                    this.errormsg=error;
                    this.isBusy.Refuser=false;
                    
                    let value =  {action : data.action ,error : this.error};
                    this.$emit('AccepterRefuser',value);
                });
            },

            
    },

}
</script>